import {createRouter, createWebHistory} from 'vue-router';
import Home from './views/Home.vue';
import EditSong from './views/EditSong.vue';
import Login from './views/Login.vue';
import store from './store';

const history = createWebHistory()
const router = createRouter({
    history,
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                allowAnonymous: true
            }
        },
        {
            path: '/edit-song',
            name: 'new-song',
            component: EditSong,
        },
        {
            path: '/edit-song/:songId',
            name: 'modify-song',
            component: EditSong
        }
    ],
    scrollBehavior() {
        return { top: 0 };
    }
});

router.beforeEach(async (to, from, next) => {
    const isLoggedIn = await store.dispatch('verifyLogin');
    if (to.name === 'login' && isLoggedIn) {
        next({ path: '/' })
    }
    else if (!to.meta.allowAnonymous && !isLoggedIn) {
        next({
            path: '/login',
            query: { redirect: to.fullPath }
        })
    }
    else {
        next()
    }
})

export default router